module.exports = __webpack_public_path__ + "static/media/meditation-primary.62af0599.svg";